import request from '@/utils/crm-request'
// 获取支付协议
export function getOption(params) {
  return request({
    url: '/pay/pay/getOption',
    method: 'get',
    params
  })
}

// 输入手机号支付
export function getMobile(params) {
  return request({
    url: 'pay/pay/payByMobile',
    method: 'get',
    params
  })
}

// 支付成功
export function payOver(params) {
  return request({
    url: 'pay/pay/successWx',
    method: 'get',
    params
  })
}
